

















































import { Component, Mixins, Prop, Vue, Ref } from 'vue-property-decorator'
import EditDialogMixin from '@/common/dialogs/mixins/edit-dialog-mixin'
import Competence from '@/competences/entities/competence'

@Component
export default class CompetenceDialog extends Mixins<
  EditDialogMixin<Competence>
>(EditDialogMixin) {
  @Prop({ type: Boolean, default: false })
  private hideRating!: boolean

  @Prop({ type: Boolean, default: false })
  private hideTemplateOptions!: boolean

  // editMode && hideTemplateOptionsOnEdit
  // @Prop({ type: Boolean, default: false })
  // private hideTemplateOptionsOnEdit!: boolean

  model = new Competence()
}
